import CollaboratorsMenu from "./CollaboratorsMenu";

export default CollaboratorsMenu;
